import LogoUploadDescription from './description';
import LogoUploader from './uploader';

type TUploadLogoProps = {
  file: File | string | undefined;
  setFile: React.Dispatch<React.SetStateAction<File | undefined>>;
};

const UploadLogo = ({file, setFile}: TUploadLogoProps) => {
  return (
    <>
      <div>
        <span>تصویر لوگو</span>
      </div>

      <div className="d-flex justify-content-between position-relative ">
        <LogoUploadDescription />
        <div>
          <LogoUploader file={file} setFile={setFile} />
        </div>
      </div>
    </>
  );
};

export default UploadLogo;
